function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
import PropTypes from "prop-types";
var SvgVeiculosEAcessorios = function SvgVeiculosEAcessorios(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size,
    height: props.size
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.384 10h-.86l-3.9-4.552a2.001 2.001 0 00-1.52-.698h-6.04a3.5 3.5 0 00-3.365 2.539L3.924 10a3.5 3.5 0 00-3.448 3.066l-.21 1.686A2 2 0 002.25 17h.84a2.751 2.751 0 005.41 0h6.59a2.751 2.751 0 005.41 0h.627a2 2 0 001.941-2.481l-.743-3A2 2 0 0020.384 10zM5.66 7.563L4.964 10h6.252l.747-4.25h-3.9A2.5 2.5 0 005.66 7.563zm7.318-1.813L12.231 10h5.977l-3.344-3.901a1.001 1.001 0 00-.76-.349h-1.126zM8.5 16h6.591a2.751 2.751 0 015.41 0h.627a1 1 0 00.97-1.24l-.743-3a1 1 0 00-.97-.76H3.95a2.5 2.5 0 00-2.481 2.19l-.211 1.686A1 1 0 002.25 16h.84a2.751 2.751 0 015.41 0zm-2.704 2.25a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5zm12 0a1.75 1.75 0 100-3.5 1.75 1.75 0 000 3.5z",
    fill: props.color
  }));
};
SvgVeiculosEAcessorios.propTypes = process.env.NODE_ENV !== "production" ? {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
SvgVeiculosEAcessorios.defaultProps = {
  color: "currentColor",
  size: "24"
};
export default SvgVeiculosEAcessorios;